import { ReactElement, ReactNode } from 'react';

import styles from './LimitedTimeOffering.module.scss';

type Props = {
  title: string
  children: ReactNode
}

function About({
  title,
  children,
}: Props): ReactElement {
  return (
    <>
      <div className={styles.about_title}>{title}</div>
      <div className={styles.about_container}>
        <div className={styles.about_row}>
          {children}
        </div>
      </div>
    </>
  );
}

export default About;
